// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!./node_modules/css-loader/dist/cjs.js!./node_modules/primereact/resources/primereact.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!./node_modules/css-loader/dist/cjs.js!./node_modules/primereact/resources/themes/lara-light-indigo/theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!./node_modules/css-loader/dist/cjs.js!./core/assets/icons/font-awesome-6/css/all.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!./node_modules/css-loader/dist/cjs.js!./node_modules/@mantine/core/styles.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!./node_modules/css-loader/dist/cjs.js!./node_modules/@mantine/dates/styles.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "./node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./core/assets/fonts/OpenSans/OpenSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./core/assets/fonts/OpenSans/OpenSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./core/assets/fonts/OpenSans/OpenSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./core/assets/fonts/OpenSans/OpenSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./core/assets/fonts/OpenSans/OpenSans-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.6 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.block {
  display: block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-full {
  width: 100%;
}
.max-w-\\[100\\%\\] {
  max-width: 100%;
}
.max-w-\\[150px\\] {
  max-width: 150px;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.resize {
  resize: both;
}
.break-all {
  word-break: break-all;
}
.border {
  border-width: 1px;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.underline {
  text-decoration-line: underline;
}
.outline {
  outline-style: solid;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.\\[contenthash\\:8\\] {
  contenthash: 8;
}

@font-face {
    font-family: 'Open Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: 400;
    font-display: swap;
}

@font-face {
    font-family: 'Open Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: 500;
    font-display: swap;
}

@font-face {
    font-family: 'Open Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
    font-weight: 600;
    font-display: swap;
}

@font-face {
    font-family: 'Open Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: 700;
    font-display: swap;
}

@font-face {
    font-family: 'Open Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
    font-weight: 900;
    font-display: swap;
}

/*&::-webkit-scrollbar-track {*/
/*    width: 4px;*/
/*}*/
/*&::-webkit-scrollbar {*/
/*    width: 4px;*/
/*}*/
/*&::-webkit-scrollbar-thumb {*/
/*    background-color: var(--scrollbar-scrollbar-default);*/
/*}*/

::webkit-scrollbar-track,
::webkit-scrollbar-thumb {
    z-index: 1;
}

.grecaptcha-badge {
    visibility: hidden;
}

.chakra-collapse[style*='height: auto'] {
    overflow: initial !important;
}

.an-simple-select__option.an-simple-select__option--is-selected,
.an-simple-select__option.an-simple-select__option--is-focused,
.an-simple-select__option:hover {
    background-color: #f5f5f5 !important;
    color: #1a1a1a !important;
}

.swiper-button-disabled {
    display: none !important;
}

.content.collapsed {
    position: relative;
}

.content.collapsed:after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
}

.content ol,
.content ul {
    padding-left: 20px;
    margin-left: 20px;
}

.content ol {
    list-style-type: decimal;
}

.content ul {
    list-style-type: disc;
}

.content li {
    font-size: 14px;
    line-height: 24px;
    color: inherit;
}

.content h1 {
    font-size: 24px;
    color: inherit;
    font-weight: 600;
    line-height: 35px;
    padding-bottom: 16px;
}

.content h1+p {
    font-size: 14px;
    color: inherit;
    line-height: 24px;
    /* margin-bottom: 48px; */
}

.content h2 {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    color: inherit;
    margin-top: 24px;
}

.content h3 {
    font-size: 16px;
    font-weight: 600;
    line-height: 28px;
    color: inherit;
    margin-top: 24px;
}

.content h4 {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: inherit;
    /* margin-top: 48px; */
}

.content p {
    /* margin-top: 24px; */
    /* margin: 24px 0; */
    color: inherit;
    font-size: 14px;
    line-height: 24px;
}

.content {
    font-size: 14px;
    line-height: 24px;
}

.content ul {
    list-style-type: disc;
    padding-left: 25px;
    padding-bottom: 15px;
    color: inherit;
    line-height: 24px;
}

.content li {
    font-size: 14px;
    color: inherit;
}

/* .content a {
    color: #245AF0;
    text-decoration: underline;
}

.content a:hover {
    color: #1D48C0;
} */

.grecaptcha-badge {
    z-index: 9999;
}

.p-dialog-error {
    animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}

@keyframes shake {

    10%,
    90% {
        transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
        transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
        transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
        transform: translate3d(4px, 0, 0);
    }
}

.pointer-cursor {
    cursor: pointer;
}

.p-dialog {
    width: 544px;
    height: 640px;
    border-radius: 8px !important;
    border: 1px solid #ccc !important;
    box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.08);
    font-family: 'Open Sans', sans-serif !important;
    overflow: hidden !important;
}

.p-dialog .p-dialog-header {
    padding: 12px 24px !important;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.08) !important;
    border-bottom: 1px solid #ebebeb !important;
}

.p-dialog-maximized {
    width: 800px !important;
    height: auto !important;
    margin: 12px !important;
    top: auto !important;
    left: auto !important;
}

.p-dialog-header-icon:hover {
    background-color: transparent !important;
}

.p-dialog-header-icon {
    box-shadow: none !important;
}

.p-dialog-hidden {
    display: none !important;
    visibility: hidden !important;
}

.p-dialog-default {
    max-height: 640px !important;
}

/* .p-dialog.p-component.p-dialog-content-hidden.apply-window-dialog-expanded.p-dialog-maximized.p-ripple-disabled{
    height: calc(100% - 95px) !important;
} */
.p-dialog.p-component.job-apply-dialog-maximized.p-dialog-default.p-ripple-disabled {
    max-height: calc(100% - 95px) !important;
    margin-bottom: 0px !important;
}

.p-dialog.p-component.p-dialog-content-hidden.p-dialog-default.p-ripple-disabled {
    margin-bottom: 0px !important;
}

.p-dialog-content-hidden {
    box-shadow: none !important;
    /*height: auto !important;*/
}

.p-dialog-content-hidden:not(.p-dialog-maximized) {
    max-height: 640px !important;
}

.p-dialog .p-dialog-header-icons {
    align-self: center;
}

.p-dialog-mask {
    background-color: transparent !important;
}

.p-dialog-mask.p-component-overlay {
    pointer-events: none;
}

.p-overflow-hidden {
    overflow: auto !important;
}

.p-dialog-mask {
    z-index: 10 !important;
}

.p-dialog-header-icon {
    border-radius: 8px !important;
    min-weight: 32px !important;
}

.p-dialog-header-icon:hover {
    background-color: #f5f5f5 !important;
}

@media (max-width: 992px) {
    .p-dialog-maximized {
        margin: 0 !important;
    }

    .p-dialog-content-hidden-sticky {
        bottom: 83px !important;
    }

    .p-dialog {
        /*max-height: 90% !important;*/
    }

    /* .content p {
        margin: 20px 0;
    } */

    /*-------Apply Window Dialog-------*/
    .p-dialog-content-hidden-sticky.p-dialog-maximized {
        height: auto !important;
        max-height: calc(100% - 83px) !important;
    }

    .p-dialog-content-hidden-sticky {
        height: auto;
    }

    .apply-window-dialog-expanded {
        height: 100%;
    }

    /*-------- end ---------*/
}

@media (min-width: 992px) {
    .p-dialog-content-hidden {
        max-height: 800px !important;
    }

    .p-dialog-maximized {
        max-height: 90% !important;
    }

    .job-apply-dialog-maximized {
        max-height: calc(100% - 0.75em) !important;
        /*height: 100% !important;*/
    }
}

.custom-swiper .swiper-slide {
    width: auto !important;
}

.chakra-checkbox__label {
    width: 100%;
}

.PostInfo-content {}

.header-ul-ol ol,
.header-ul-ol ul {
    margin-left: 20px;
    padding-left: 20px;
}

.header-ul-ol ol {
    list-style-type: decimal;
}

.header-ul-ol ul {
    list-style-type: disc;
}

.header-ul-ol li {
    margin-bottom: 4px;
    line-height: 12px;
}

.header-ul-ol strong {
    font-weight: bold;
}

.PostInfo-content ol {
    list-style-type: decimal;
    padding-left: 16px;
}

/* logwork */

/* .mantine-DatePickerInput-day[data-in-range] {
    background: #eaf2fd;
    color: #2f80ed;
}

.mantine-DatePickerInput-day[date-first-in-range] {
    position: relative;
}

.mantine-DatePickerInput-monthCell:has(> .mantine-DatePickerInput-day[data-first-in-range]) {
    background: #eaf2fd;
    border-top-left-radius: 100%;
    border-bottom-left-radius: 100%;
}

.mantine-DatePickerInput-monthCell:has(> .mantine-DatePickerInput-day[data-last-in-range]) {
    background: #eaf2fd;
    border-top-right-radius: 100%;
    border-bottom-right-radius: 100%;
}

.mantine-DatePickerInput-day[data-selected] {
    background: #2f80ed !important;
    color: #fff;
    border-radius: 100%;
}

.mantine-DatePickerInput-day:hover {
    background-color: #2f80ed !important;
    color: #fff;
    border-radius: 100%;
}

.mantine-DatePickerInput-monthCell[data-with-spacing] {
    padding: 0;
} */
.post-list-select {
    max-height: 36px;
}

.react-select__menu-portal {
    z-index: 5555 !important;
}

.ContactPerson__modal__icon {
    display: inline-flex;
    align-items: center;
    width: 18px;
    justify-content: center;
}

.ContactPerson__contact-link {}

.ContactPerson__contact-link .ContactPerson__modal__icon {
    display: none;
    cursor: pointer;
}

.ContactPerson__contact-link:hover .ContactPerson__modal__icon {
    display: inline-flex;
}

/*.react-select__menu {*/
/*    z-index: 9999 !important;*/
/*    position: absolute !important;*/
/*}*/

/*.lazy-load-image-background {*/
/*    width: 100%;*/
/*    display: flex !important;*/
/*    justify-content: center;*/
/*    align-items: center;*/
/*}*/
`, "",{"version":3,"sources":["webpack://./index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,0BAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAOnB;IACI,wBAAwB;IACxB,+DAAgF;IAChF,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,+DAA+E;IAC/E,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,+DAAiF;IACjF,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,+DAA6E;IAC7E,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,+DAAkF;IAClF,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,+BAA+B;AAC/B,kBAAkB;AAClB,IAAI;AACJ,yBAAyB;AACzB,kBAAkB;AAClB,IAAI;AACJ,+BAA+B;AAC/B,4DAA4D;AAC5D,IAAI;;AAEJ;;IAEI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;;IAGI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,yEAAyE;AAC7E;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;;;;;;;GAOG;;AAEH;IACI,aAAa;AACjB;;AAEA;IACI,gEAAgE;AACpE;;AAEA;;IAEI;;QAEI,kCAAkC;IACtC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;;QAGI,kCAAkC;IACtC;;IAEA;;QAEI,iCAAiC;IACrC;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,iCAAiC;IACjC,iDAAiD;IACjD,+CAA+C;IAC/C,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,0DAA0D;IAC1D,2CAA2C;AAC/C;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;GAEG;AACH;IACI,wCAAwC;IACxC,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;;OAEG;;IAEH,oCAAoC;IACpC;QACI,uBAAuB;QACvB,wCAAwC;IAC5C;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA,yBAAyB;AAC7B;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0CAA0C;QAC1C,2BAA2B;IAC/B;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA,mBAAmB;;AAEnB;;IAEI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA,YAAY;;AAEZ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAmCG;AACH;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;AAC3B;;AAEA,8BAA8B;;AAE9B;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,wBAAwB;AACxB,gCAAgC;AAChC,qCAAqC;AACrC,IAAI;;AAEJ,gCAAgC;AAChC,mBAAmB;AACnB,gCAAgC;AAChC,+BAA+B;AAC/B,2BAA2B;AAC3B,IAAI","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import 'primereact/resources/primereact.min.css';\n@import 'primereact/resources/themes/lara-light-indigo/theme.css';\n@import './core/assets/icons/font-awesome-6/css/all.min.css';\n@import '@mantine/core/styles.css';\n@import '@mantine/dates/styles.css';\n\n@font-face {\n    font-family: 'Open Sans';\n    src: url('./core/assets/fonts/OpenSans/OpenSans-Regular.ttf') format('truetype');\n    font-weight: 400;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Open Sans';\n    src: url('./core/assets/fonts/OpenSans/OpenSans-Medium.ttf') format('truetype');\n    font-weight: 500;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Open Sans';\n    src: url('./core/assets/fonts/OpenSans/OpenSans-SemiBold.ttf') format('truetype');\n    font-weight: 600;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Open Sans';\n    src: url('./core/assets/fonts/OpenSans/OpenSans-Bold.ttf') format('truetype');\n    font-weight: 700;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Open Sans';\n    src: url('./core/assets/fonts/OpenSans/OpenSans-ExtraBold.ttf') format('truetype');\n    font-weight: 900;\n    font-display: swap;\n}\n\n/*&::-webkit-scrollbar-track {*/\n/*    width: 4px;*/\n/*}*/\n/*&::-webkit-scrollbar {*/\n/*    width: 4px;*/\n/*}*/\n/*&::-webkit-scrollbar-thumb {*/\n/*    background-color: var(--scrollbar-scrollbar-default);*/\n/*}*/\n\n::webkit-scrollbar-track,\n::webkit-scrollbar-thumb {\n    z-index: 1;\n}\n\n.grecaptcha-badge {\n    visibility: hidden;\n}\n\n.chakra-collapse[style*='height: auto'] {\n    overflow: initial !important;\n}\n\n.an-simple-select__option.an-simple-select__option--is-selected,\n.an-simple-select__option.an-simple-select__option--is-focused,\n.an-simple-select__option:hover {\n    background-color: #f5f5f5 !important;\n    color: #1a1a1a !important;\n}\n\n.swiper-button-disabled {\n    display: none !important;\n}\n\n.content.collapsed {\n    position: relative;\n}\n\n.content.collapsed:after {\n    content: '';\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%);\n}\n\n.content ol,\n.content ul {\n    padding-left: 20px;\n    margin-left: 20px;\n}\n\n.content ol {\n    list-style-type: decimal;\n}\n\n.content ul {\n    list-style-type: disc;\n}\n\n.content li {\n    font-size: 14px;\n    line-height: 24px;\n    color: inherit;\n}\n\n.content h1 {\n    font-size: 24px;\n    color: inherit;\n    font-weight: 600;\n    line-height: 35px;\n    padding-bottom: 16px;\n}\n\n.content h1+p {\n    font-size: 14px;\n    color: inherit;\n    line-height: 24px;\n    /* margin-bottom: 48px; */\n}\n\n.content h2 {\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 24px;\n    color: inherit;\n    margin-top: 24px;\n}\n\n.content h3 {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 28px;\n    color: inherit;\n    margin-top: 24px;\n}\n\n.content h4 {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    color: inherit;\n    /* margin-top: 48px; */\n}\n\n.content p {\n    /* margin-top: 24px; */\n    /* margin: 24px 0; */\n    color: inherit;\n    font-size: 14px;\n    line-height: 24px;\n}\n\n.content {\n    font-size: 14px;\n    line-height: 24px;\n}\n\n.content ul {\n    list-style-type: disc;\n    padding-left: 25px;\n    padding-bottom: 15px;\n    color: inherit;\n    line-height: 24px;\n}\n\n.content li {\n    font-size: 14px;\n    color: inherit;\n}\n\n/* .content a {\n    color: #245AF0;\n    text-decoration: underline;\n}\n\n.content a:hover {\n    color: #1D48C0;\n} */\n\n.grecaptcha-badge {\n    z-index: 9999;\n}\n\n.p-dialog-error {\n    animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n}\n\n@keyframes shake {\n\n    10%,\n    90% {\n        transform: translate3d(-1px, 0, 0);\n    }\n\n    20%,\n    80% {\n        transform: translate3d(2px, 0, 0);\n    }\n\n    30%,\n    50%,\n    70% {\n        transform: translate3d(-4px, 0, 0);\n    }\n\n    40%,\n    60% {\n        transform: translate3d(4px, 0, 0);\n    }\n}\n\n.pointer-cursor {\n    cursor: pointer;\n}\n\n.p-dialog {\n    width: 544px;\n    height: 640px;\n    border-radius: 8px !important;\n    border: 1px solid #ccc !important;\n    box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.08);\n    font-family: 'Open Sans', sans-serif !important;\n    overflow: hidden !important;\n}\n\n.p-dialog .p-dialog-header {\n    padding: 12px 24px !important;\n    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.08) !important;\n    border-bottom: 1px solid #ebebeb !important;\n}\n\n.p-dialog-maximized {\n    width: 800px !important;\n    height: auto !important;\n    margin: 12px !important;\n    top: auto !important;\n    left: auto !important;\n}\n\n.p-dialog-header-icon:hover {\n    background-color: transparent !important;\n}\n\n.p-dialog-header-icon {\n    box-shadow: none !important;\n}\n\n.p-dialog-hidden {\n    display: none !important;\n    visibility: hidden !important;\n}\n\n.p-dialog-default {\n    max-height: 640px !important;\n}\n\n/* .p-dialog.p-component.p-dialog-content-hidden.apply-window-dialog-expanded.p-dialog-maximized.p-ripple-disabled{\n    height: calc(100% - 95px) !important;\n} */\n.p-dialog.p-component.job-apply-dialog-maximized.p-dialog-default.p-ripple-disabled {\n    max-height: calc(100% - 95px) !important;\n    margin-bottom: 0px !important;\n}\n\n.p-dialog.p-component.p-dialog-content-hidden.p-dialog-default.p-ripple-disabled {\n    margin-bottom: 0px !important;\n}\n\n.p-dialog-content-hidden {\n    box-shadow: none !important;\n    /*height: auto !important;*/\n}\n\n.p-dialog-content-hidden:not(.p-dialog-maximized) {\n    max-height: 640px !important;\n}\n\n.p-dialog .p-dialog-header-icons {\n    align-self: center;\n}\n\n.p-dialog-mask {\n    background-color: transparent !important;\n}\n\n.p-dialog-mask.p-component-overlay {\n    pointer-events: none;\n}\n\n.p-overflow-hidden {\n    overflow: auto !important;\n}\n\n.p-dialog-mask {\n    z-index: 10 !important;\n}\n\n.p-dialog-header-icon {\n    border-radius: 8px !important;\n    min-weight: 32px !important;\n}\n\n.p-dialog-header-icon:hover {\n    background-color: #f5f5f5 !important;\n}\n\n@media (max-width: 992px) {\n    .p-dialog-maximized {\n        margin: 0 !important;\n    }\n\n    .p-dialog-content-hidden-sticky {\n        bottom: 83px !important;\n    }\n\n    .p-dialog {\n        /*max-height: 90% !important;*/\n    }\n\n    /* .content p {\n        margin: 20px 0;\n    } */\n\n    /*-------Apply Window Dialog-------*/\n    .p-dialog-content-hidden-sticky.p-dialog-maximized {\n        height: auto !important;\n        max-height: calc(100% - 83px) !important;\n    }\n\n    .p-dialog-content-hidden-sticky {\n        height: auto;\n    }\n\n    .apply-window-dialog-expanded {\n        height: 100%;\n    }\n\n    /*-------- end ---------*/\n}\n\n@media (min-width: 992px) {\n    .p-dialog-content-hidden {\n        max-height: 800px !important;\n    }\n\n    .p-dialog-maximized {\n        max-height: 90% !important;\n    }\n\n    .job-apply-dialog-maximized {\n        max-height: calc(100% - 0.75em) !important;\n        /*height: 100% !important;*/\n    }\n}\n\n.custom-swiper .swiper-slide {\n    width: auto !important;\n}\n\n.chakra-checkbox__label {\n    width: 100%;\n}\n\n.PostInfo-content {}\n\n.header-ul-ol ol,\n.header-ul-ol ul {\n    margin-left: 20px;\n    padding-left: 20px;\n}\n\n.header-ul-ol ol {\n    list-style-type: decimal;\n}\n\n.header-ul-ol ul {\n    list-style-type: disc;\n}\n\n.header-ul-ol li {\n    margin-bottom: 4px;\n    line-height: 12px;\n}\n\n.header-ul-ol strong {\n    font-weight: bold;\n}\n\n.PostInfo-content ol {\n    list-style-type: decimal;\n    padding-left: 16px;\n}\n\n/* logwork */\n\n/* .mantine-DatePickerInput-day[data-in-range] {\n    background: #eaf2fd;\n    color: #2f80ed;\n}\n\n.mantine-DatePickerInput-day[date-first-in-range] {\n    position: relative;\n}\n\n.mantine-DatePickerInput-monthCell:has(> .mantine-DatePickerInput-day[data-first-in-range]) {\n    background: #eaf2fd;\n    border-top-left-radius: 100%;\n    border-bottom-left-radius: 100%;\n}\n\n.mantine-DatePickerInput-monthCell:has(> .mantine-DatePickerInput-day[data-last-in-range]) {\n    background: #eaf2fd;\n    border-top-right-radius: 100%;\n    border-bottom-right-radius: 100%;\n}\n\n.mantine-DatePickerInput-day[data-selected] {\n    background: #2f80ed !important;\n    color: #fff;\n    border-radius: 100%;\n}\n\n.mantine-DatePickerInput-day:hover {\n    background-color: #2f80ed !important;\n    color: #fff;\n    border-radius: 100%;\n}\n\n.mantine-DatePickerInput-monthCell[data-with-spacing] {\n    padding: 0;\n} */\n.post-list-select {\n    max-height: 36px;\n}\n\n.react-select__menu-portal {\n    z-index: 5555 !important;\n}\n\n.ContactPerson__modal__icon {\n    display: inline-flex;\n    align-items: center;\n    width: 18px;\n    justify-content: center;\n}\n\n.ContactPerson__contact-link {}\n\n.ContactPerson__contact-link .ContactPerson__modal__icon {\n    display: none;\n    cursor: pointer;\n}\n\n.ContactPerson__contact-link:hover .ContactPerson__modal__icon {\n    display: inline-flex;\n}\n\n/*.react-select__menu {*/\n/*    z-index: 9999 !important;*/\n/*    position: absolute !important;*/\n/*}*/\n\n/*.lazy-load-image-background {*/\n/*    width: 100%;*/\n/*    display: flex !important;*/\n/*    justify-content: center;*/\n/*    align-items: center;*/\n/*}*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
